import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerItems,
  StyledContainerFooterSideBar,
  StyledTitleSideBar
} from '../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { SideBarDeleteActionWithPopup } from '../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import Strings from '../../i18n';
import { IScheduleFirmwareData } from '../../types/Device/DeviceInterfaces';
import { useDeleteScheduleFirmwareUpdateMutation } from '../../services/firmwareVersions/firmwareVersionsService';
import { SideBarSimpleMethodItem } from '../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { useDeviceRebootCommandMutation } from '../../services/device/deviceService';

interface ScheduleFirmwareSingleDetailsProps {
  closeSideBar: () => void;
  selectedSchedules: IScheduleFirmwareData[];
  reloadTable: () => void;
}
export const ScheduleFirmwareSingleDetails = ({
  closeSideBar,
  selectedSchedules,
  reloadTable
}: ScheduleFirmwareSingleDetailsProps) => {
  const [deleteSchedule, { isSuccess: successDeleteSchedule }] =
    useDeleteScheduleFirmwareUpdateMutation();
  const [
    rebootDevicesCommand,
    { isSuccess: isSuccessRebootDevice, isLoading: isLoadingRebootDevice }
  ] = useDeviceRebootCommandMutation();
  const deleteFirmwareSchedule = () => {
    deleteSchedule(
      selectedSchedules.map((item) => {
        return {
          id: item.firmwareScheduleId,
          firmwareversion: item.targetFirmwareVersion
        };
      })
    );
  };

  useEffect(() => {
    if (successDeleteSchedule) {
      closeSideBar();
      reloadTable();
      toast.success(Strings.serverAccess.scheduleFirmwareUpdate.deleteSuccess);
    }
  }, [successDeleteSchedule]);
  useEffect(() => {
    if (isSuccessRebootDevice) {
      toast.success(Strings.serverAccess.devices.successRebootDevice);
      reloadTable();
      closeSideBar();
    }
  }, [isSuccessRebootDevice]);
  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.common.details}</StyledTitleSideBar>
        <SideBarSimpleMethodItem
          name={Strings.serverAccess.devices.rebootDevicesLabel}
          action={() => {
            rebootDevicesCommand(
              selectedSchedules.map((item) => item.deviceId)
            );
          }}
          successAction={false}
          textSuccess="success"
          loading={isLoadingRebootDevice}
        />
        <SideBarDeleteActionWithPopup
          onDelete={() => deleteFirmwareSchedule()}
          titleConfirmation={
            Strings.serverAccess.scheduleFirmwareUpdate.deleteFirmwareTitle
          }
          textConfirmation={Strings.common.thisActionIsIrreversible}
          textIcon={Strings.serverAccess.scheduleFirmwareUpdate.deleteFirmware}
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => closeSideBar()}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
